import React, { Component, Fragment  } from 'react';
import {
    Collapse,
    Container,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge
  } from 'reactstrap';
  import '@fortawesome/fontawesome-free/css/all.css';
interface PropsFromState {
    
}

interface PropsFromDispatch {
    
    login: any
}


type AllProps = PropsFromState & PropsFromDispatch

export default class RedirectHome  extends Component<AllProps> {

    renderHeader(){
        return (
            <div>
              <Navbar color="" dark expand="md" fixed="top" style={{backgroundColor:"#3A3A3C", "height":"72px"}}>
                <Container>
                  <NavbarBrand href="/">
                    {/* <i className="fas fa-globe-americas mr-1"></i>Ultimates Pro */}
                    <img src="/images/logo.png" height="40px" alt="Logo"/>
                  </NavbarBrand>
                  
                </Container>
              </Navbar>
            </div>
          );
    }
    render() {
        return (
            <Fragment>
                {this.renderHeader()}
                <main role="main">
                    <Container className="bg-light pb-3" style={{textAlign:"center"}}>
                      <br/>Please login to access <br/><br/>
                      <button onClick={this.props.login} className="btn btn-primary" >Login</button>
                    </Container>
                </main>
                <footer className="footer">
                    <div className="container">
                    <span className="" style={{fontSize:"smaller"}}>© Ultimates Pro Copyrights 2020</span>
                    </div>
                </footer>
            </Fragment>
        );
    }
}
